import { TInitialState } from '~/src/features/tariffBuilder/reducer';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';

/**
 * Checks the availability of equipment
 */
export const hasSelectedEquipment = (state: TInitialState) => {
    const decoders = Object.values(state[EEntity.decoders]);
    const routers = Object.values(state[EEntity.routers]);
    return [...decoders, ...routers].some((equip) => equip.quantity > 0);
};
